module.exports = __webpack_public_path__ + "img/service3.64acd040.svg";